import type { ChangeEvent } from "react"
import { BRACKET_SIZE_OPTIONS } from "@/domain/bracket/model/Bracket"

interface AdminBracketSizeFieldProps {
  id: string
  value: string
  onChange: (value: string) => void
}

/**
 * 편성 규모 선택 칸.
 *
 * 편성 · 재편성 · 전체 편성 확인 모달 안에 둔다 — 규모는 뽑을 때 정하는 값이라
 * 화면 위에 따로 두면 누른 버튼과 떨어져 어떤 규모로 뽑히는지 놓치기 쉽다.
 */
export default function AdminBracketSizeField({
  id,
  value,
  onChange,
}: Readonly<AdminBracketSizeFieldProps>) {
  function onChangeSize(event: ChangeEvent<HTMLSelectElement>) {
    onChange(event.target.value)
  }

  return (
    <div className="mt-4 flex flex-col gap-1.5">
      <label
        htmlFor={id}
        className="app-label-sub"
      >
        편성 규모
      </label>
      <select
        id={id}
        value={value}
        onChange={onChangeSize}
        className="focus-ring app-field w-full"
      >
        {BRACKET_SIZE_OPTIONS.map((option) => (
          <option
            key={option.value}
            value={option.value}
          >
            {option.label}
          </option>
        ))}
      </select>
    </div>
  )
}
